<template>
  <pie-chart
    :height="height"
    :chart-data="chartConfig"
  />
</template>

<script>
import { Charts } from "@/components/Charts/config";
import PieChart from '@/components/Charts/PieChart';

export default {
  name: 'AvaliationBooleanChart',
  components: { PieChart },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      default: 250,
    },
  },
  computed: {
    falsies() {
      return this.chartData.data["F"] || 0 + this.chartData.data["f"] || 0 + this.chartData.data["false"] || 0 + this.chartData.data["False"] || 0 + this.chartData.data["FALSE"] || 0;
    },
    truths() {
      return this.chartData.data["T"] || 0 + this.chartData.data["t"] || 0 + this.chartData.data["true"] || 0 + this.chartData.data["True"] || 0 + this.chartData.data["TRUE"] || 0;
    },
    chartConfig() {
      if (!this.chartData || !this.chartData.data) return {};

      return {
        labels: [
          'Não',
          'Sim',
        ],
        datasets: [{
          data: [
            this.falsies,
            this.truths,
          ],
          backgroundColor: [
            Charts.colors.theme['warning'],
            Charts.colors.theme['success'],
          ],
        }],
      };
    },
  }
}
</script>
